import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Locales } from 'types/locale';

import { select as selectLocale } from 'utils/locale';

import Portal from 'components/modules/public/layout/modals/Portal';
import SectionHero from 'components/modules/public/layout/sections/Hero';
import { useCountdown } from 'hooks/useCountdown';

import StyledComponent from './styles';
import { Props } from './types';

const BlackMonthCounter: FunctionComponent<Props> = ({ sectionSettings }) => {
    const [days, hours, minutes, seconds] = useCountdown(sectionSettings?.filters?.timerCountdownTo);
    const hasNavigation = !sectionSettings?.filters?.isNavigationSwitchEnabled;
    const isExpired = (days + hours + minutes + seconds) < 0 || isNaN((days + hours + minutes + seconds));

    const localTranslations = selectLocale({
        [Locales.En]: require('./locales/en.json'),
        [Locales.Pl]: require('./locales/pl.json'),
    });

    return (
        <StyledComponent className="public-section-hero-variant-default">
            {(sectionSettings?.filters?.isTimerSwitchEnabled && !isExpired) && (
                <>
                    <div className={classnames(
                        {
                            'counter': true,
                            'has-navigation': hasNavigation,
                        })}
                    >
                        <div className="counter-label">
                            <span>{localTranslations?.counter?.valid}</span>
                        </div>
                        <div className="day">
                            {days < 10 ? '0' : ''}{days}
                            <span>{localTranslations?.counter?.day}</span>
                        </div>
                        <div className="hours">
                            {hours < 10 ? '0' : ''}{hours}
                            <span>{localTranslations?.counter?.hour}</span>
                        </div>
                        <div className="minutes">
                            {minutes < 10 ? '0' : ''}{minutes}
                            <span>{localTranslations?.counter?.minute}</span>
                        </div>
                        <div className="seconds">
                            {seconds < 10 ? '0' : ''}{seconds}
                            <span>{localTranslations?.counter?.second}</span>
                        </div>
                    </div>
                </>
            )}
            {(sectionSettings?.filters?.isTimerSwitchEnabled && isExpired) && (
                <div className="counter">
                    <div className="expired">
                        {localTranslations?.counter?.expired}
                    </div>
                </div>
            )}
        </StyledComponent>
    );
};

const PublicSectionHeroVariantDefault: FunctionComponent<Props> = ({ translations, sectionSettings }) => {
    return (
        <StyledComponent className="public-section-hero-variant-default">
            <Portal removeScrollBlocker >
                <BlackMonthCounter sectionSettings={sectionSettings} />
            </Portal>
            <SectionHero {...translations} />
        </StyledComponent>
    );
};

export default PublicSectionHeroVariantDefault;
